import { lineSetting } from 'settings/custom/lines'

export class LinePoints {
  constructor() {
    this.itemHeight = game.models.ItemsModel.height
    this.itemWidth = game.models.ItemsModel.width
    this.points = null

  }

  create(pathLine, line) {
    this.points = []

    pathLine.forEach((item, i) => {
      switch (lineSetting.drawType) {
        case 'ultraHot' : this.ultraHot.call(this, item, i, pathLine, line)
          break
        case 'center' : this.center.call(this, item, i, pathLine, line)
          break
        default: this.regular.call(this, item, i, pathLine)
      }
    })

    return this.points
  }

  ultraHot(item, i, pathLine, line) {
    if (line ==  3 ){
      if (i == 0) {
        this.points.push( [
          0,
          (item *  this.itemHeight),
        ])
      }

      this.points.push( [

        (i *  this.itemWidth) +  this.itemWidth / 2,
        (item *  this.itemHeight) +  this.itemHeight / 2,
      ])

      if (i == pathLine.length - 1) {
        this.points.push( [
          pathLine.length *  this.itemWidth,
          (pathLine.length *  this.itemHeight),
        ])
      }
    }
    else if (line ==  4){
      if (i == 0) {
        this.points.push( [

          0,
          (item *  this.itemHeight) +  this.itemHeight,
        ])
      }

      this.points.push([

        (i *  this.itemWidth) +  this.itemWidth / 2,
        (item *  this.itemHeight) +  this.itemHeight / 2,
      ])

      if (i == pathLine.length - 1) {
        this.points.push( [

          pathLine.length *  this.itemWidth,
          (item *  this.itemHeight),
        ])
      }
    }
    else {
      this.regular(item, i, pathLine)
    }
  }

  regular(item, i, pathLine){
    if (i == 0) {
      this.points.push(
        [
          0,
          (item * this.itemHeight) + this.itemHeight / 2,
        ])
    }

    this.points.push(
      [
        (i * this.itemWidth) + this.itemWidth / 2,
        (item * this.itemHeight) + this.itemHeight / 2,
      ])

    if (i == pathLine.length - 1) {
      this.points.push(
        [
          pathLine.length * this.itemWidth,
          (item * this.itemHeight) + this.itemHeight / 2,
        ])
    }
  }

  center(item, i, pathLine){
    if (i == 0) {
      this.points.push(
        [
          this.itemWidth / 2,
          (item * this.itemHeight) + this.itemHeight / 2,
        ])
    }

    this.points.push([
      (i * this.itemWidth) + this.itemWidth / 2,
      (item * this.itemHeight) + this.itemHeight / 2,
    ])

    if (i == pathLine.length - 1) {
      this.points.push( [
        (pathLine.length * this.itemWidth) - this.itemWidth / 2,
        (item * this.itemHeight) + this.itemHeight / 2,
      ])
    }
  }
}
